import { render, staticRenderFns } from "./UploadPictures.vue?vue&type=template&id=6bf3a1a2&scoped=true&"
import script from "./UploadPictures.vue?vue&type=script&lang=js&"
export * from "./UploadPictures.vue?vue&type=script&lang=js&"
import style0 from "./UploadPictures.vue?vue&type=style&index=0&id=6bf3a1a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3a1a2",
  null
  
)

export default component.exports